/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Abilities_None_HintInputs */



/**
* | output |
* | --- |
* | "Nothing picked yet, so the agent keeps every ability." |
*
* @param {Agent_Builder_Abilities_None_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_abilities_none_hint = /** @type {((inputs?: Agent_Builder_Abilities_None_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Abilities_None_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch nichts ausgewählt – der Agent behält damit alle Fähigkeiten.")
	return /** @type {LocalizedString} */ ("Nothing picked yet, so the agent keeps every ability.")
});